<template>
  <div>
    <a-page-header
      @back="()=>$router.go(-1)"
      title="查看填报数据"
      style="padding-left: 0; margin-bottom: 10px; border-bottom: 1px solid rgb(235, 237, 240)"
    />
    <a-form :label-col="{span: 12}" :wrapper-col="{span: 12}">
      <a-row :gutter="20" class="mt-gap-30">
        <a-col :span="12">
          <a-form-item :label-col="{span: 2}" :wrapper-col="{span: 22}" label="标题">
            <div>{{ form.title || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="企业总数">
            <div>{{ form.enterpriseTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="企业面积">
            <div>{{ form.industryArea || "-" }}</div>
          </a-form-item>
        </a-col>
      </a-row>
      <div class="table-group">
        <div class="pb-gap-10">
          <span>产业分布数据</span>
        </div>
        <a-table :columns="industryDistributionColumn" :data-source="form.industryDistribution" :pagination="false" bordered />
      </div>
      <a-row :gutter="20" class="mt-gap-10">
        <a-col :span="8">
          <a-form-item label="荣誉资质数量">
            <div>{{ form.honorQualificationTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="上市公司数量">
            <div>{{ form.listedEnterpriseTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="国家高新技术企业数量">
            <div>{{ form.nationalHighTechEnterpriseTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="专精特新小巨人数量">
            <div>{{ form.specializedLittleGiantTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="科技型中小企业数量">
            <div>{{ form.techSmeTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="专精特新中小企业数量">
            <div>{{ form.specializedSmeTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="有融资企业数量">
            <div>{{ form.financedEnterpriseTotal || "-" }}</div>
          </a-form-item>
        </a-col>
      </a-row>
      <div class="table-group">
        <div class="pb-gap-10">
          <span>融资轮次分布</span>
        </div>
        <a-table :columns="financingRoundDistributionColumn" :data-source="form.financingRoundDistribution" :pagination="false" bordered />
      </div>
      <a-row :gutter="20" class="mt-gap-30">
        <a-col :span="8">
          <a-form-item label="知识产权总数量">
            <div>{{ form.intellectualPropertyTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="专利数量">
            <div>{{ form.patentTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="软件著作数量">
            <div>{{ form.softwareCopyrightTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="作品著作数量">
            <div>{{ form.workCopyrightTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="商标数量">
            <div>{{ form.trademarkTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="项目累计招募数量">
            <div>{{ form.recruitmentTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="项目今年招募数量">
            <div>{{ form.currentYearRecruitmentTotal || "-" }}</div>
          </a-form-item>
        </a-col>
      </a-row>
      <div class="table-group">
        <div class="pb-gap-10">
          <span>每年招募趋势</span>
        </div>
        <a-table :columns="annualRecruitmentTrendColumn" :data-source="form.annualRecruitmentTrend" :pagination="false" bordered />
      </div>
      <div class="table-group mt-gap-10">
        <div class="pb-gap-10">
          <span>项目产业分布</span>
        </div>
        <a-table :columns="projectIndustryDistributionColumn" :data-source="form.projectIndustryDistribution" :pagination="false" bordered />
      </div>
      <a-row :gutter="20" class="mt-gap-30">
        <a-col :span="8">
          <a-form-item label="班车线路数量">
            <div>{{ form.busRouteTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="每日班次数量">
            <div>{{ form.dailyBusTripTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="社群数量">
            <div>{{ form.communityTotal || "-" }}</div>
          </a-form-item>
        </a-col>
        <a-col :span="8">
          <a-form-item label="社群人数">
            <div>{{ form.communityMemberTotal || "-" }}</div>
          </a-form-item>
        </a-col>
      </a-row>
      <div class="table-group">
        <div class="pub-flex flex-jc-stretch pb-gap-10">
          <span>活跃社群 TOP5</span>
        </div>
        <a-table :columns="activeCommunityTop5Column" :data-source="form.activeCommunityTop5" :pagination="false" bordered />
      </div>
      <a-row :gutter="20" class="mt-gap-10">
        <a-col :span="8">
          <a-form-item label="孵化落地企业数量">
            <div>{{ form.incubationLandingEnterpriseTotal || "-" }}</div>
          </a-form-item>
        </a-col>
      </a-row>
      <div class="table-group">
        <div class="pb-gap-10">
          <span>孵化落地企业</span>
        </div>
        <a-table :columns="incubatedEnterpriseColumn" :data-source="incubationLandingEnterpriseList" :pagination="false" bordered />
      </div>
      <a-row :gutter="20" class="mt-gap-10">
        <a-col :span="8">
          <a-form-item label="已入住房源数">
            <div>{{ form.settledHouseTotal || "-" }}</div>
          </a-form-item>
        </a-col>
      </a-row>
      <div class="table-group">
        <div class="pb-gap-10">
          <span>房源分布</span>
        </div>
        <a-table :columns="houseCategoryDistributionColumn" :data-source="form.houseCategoryDistribution || []" :pagination="false" bordered />
      </div>
    </a-form>
  </div>
</template>
<script>
import * as api from "@/api/dataAnalysis/dataSubForm.js";
export default {
    components: {

    },
    props: {
        
    },
    data() {
        return {
          form: {},
          industryDistributionColumn: [
            {
              title: '产业名称',
              dataIndex: 'key',
              key: 'key',
              customRender: (text) => text || '-',
            },
            {
              title: '展示值',
              dataIndex: 'value',
              key: 'value',
              customRender: (text) => text || '-',
            },
          ],
          financingRoundDistributionColumn: [
            {
              title: '融资轮次',
              dataIndex: 'key',
              key: 'key',
              customRender: (text) => text || '-',
            },
            {
              title: '展示值',
              dataIndex: 'value',
              key: 'value',
              customRender: (text) => text || '-',
            },
          ],
          annualRecruitmentTrendColumn: [
            {
              title: '年份',
              dataIndex: 'key',
              key: 'key',
              customRender: (text) => text || '-',
            },
            {
              title: '招募数量',
              dataIndex: 'value',
              key: 'value',
              customRender: (text) => text || '-',
            },
          ],
          projectIndustryDistributionColumn: [
            {
              title: '产业名称',
              dataIndex: 'key',
              key: 'key',
              customRender: (text) => text || '-',
            },
            {
              title: '展示值',
              dataIndex: 'value',
              key: 'value',
              customRender: (text) => text || '-',
            },
          ],
          activeCommunityTop5Column: [
            {
              title: '社群名称',
              dataIndex: 'key',
              key: 'key',
              customRender: (text) => text || '-',
            },
            {
              title: '展示值',
              dataIndex: 'value',
              key: 'value',
              customRender: (text) => text || '-',
            },
          ],
          incubatedEnterpriseColumn: [
            {
              title: '企业名称',
              key: 'enterpriseName',
              customRender: (text, record) => record || '-',
            },
          ],
          houseCategoryDistributionColumn: [
            {
              title: '分类名称',
              dataIndex: 'key',
              key: 'key',
              customRender: (text) => text || '-',
            },
            {
              title: '展示值',
              dataIndex: 'value',
              key: 'value',
              customRender: (text) => text || '-',
            },
          ],
        }
    },
    computed: {
      incubationLandingEnterpriseList(){
        const list = this.form && this.form.incubationLandingEnterpriseList;
        if(Array.isArray(list)){
          return list;
        }
        if(typeof list === 'string' && list){
          try {
            const parsed = JSON.parse(list);
            return Array.isArray(parsed) ? parsed : [];
          } catch (e) {
            return [];
          }
        }
        return [];
      }
    },
    created(){

    },
    mounted(){
        this.getDetail();
    },
    methods: {
      getDetail(){
        this.loading = true;
        return api.getDataDetail({id: this.$route.query.id})
        .finally(()=>{
          this.loading = false;
        })
        .then(({code, data, msg})=>{
          if(code == 200){
            this.$set(this, 'form', data);
          }
        });
      }
    }
}
</script>
<style lang="scss" scoped>
  .pb-gap-10{
    padding: 0 0 10px;
  }
  .mt-gap-10{
    margin-top: 10px;
  }
  .mt-gap-30{
    margin-top: 30px;
  }
  ::v-deep .table-group th,
  ::v-deep .table-group td{
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
</style>